var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("h3", [_vm._v(_vm._s(_vm.titulo))]),
      _c(
        "el-row",
        { staticClass: "margin", attrs: { gutter: 2 } },
        [
          _c(
            "el-col",
            { attrs: { xl: 24, lg: 24, md: 24, sm: 24 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "hover" } },
                [
                  _vm._t("header", [
                    _c("h3", [
                      _vm._v(
                        "Quantidade de processo do analista - " +
                          _vm._s(_vm.$route.query.setor)
                      )
                    ])
                  ]),
                  _vm.produtividadeTipoProcesso
                    ? _c(
                        "div",
                        { staticClass: "margin" },
                        [
                          _c("grafico-produtividade", {
                            attrs: {
                              usuario: _vm.$route.query.analista,
                              dadosLabels: _vm.produtividadeTipoProcesso
                            },
                            on: { totalProcessos: _vm.setTotalProcessos }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin", attrs: { gutter: 2 } },
        [
          _c(
            "el-col",
            { attrs: { xl: 24, lg: 24, md: 24, sm: 24 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "hover" } },
                [
                  _vm._t("header", [
                    _c("h3", [_vm._v("Produtividade mensal do colaborador")])
                  ]),
                  _c(
                    "div",
                    { staticClass: "margin" },
                    [
                      _c("grafico-mensal", {
                        attrs: {
                          produtividadeUsuario:
                            _vm.produtividadeAnalista
                              .produtividadePeriodoAnoMesUsuario,
                          mediasWithDataArray:
                            _vm.produtividadeAnalista
                              .mediaProdutividadePeriodoAnoMes
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.produtividadeAnalista.processosAnalisados
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _vm.showModal
                ? _c("app-modal-visualizar-completo", {
                    attrs: {
                      showModal: _vm.showModal,
                      idProcesso: _vm.idProcesso,
                      protocolo: _vm.protocolo,
                      numeroProcesso: _vm.numeroProcesso,
                      tipo: _vm.tipoProcesso
                    },
                    on: {
                      closeModal: function($event) {
                        _vm.showModal = false
                      }
                    }
                  })
                : _vm._e(),
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "titulo" }, [
                      _vm._v("Processos analisados")
                    ])
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      attrs: {
                        data:
                          _vm.produtividadeAnalista.processosAnalisados.content,
                        "element-loading-text": "Carregando..."
                      },
                      on: { "sort-change": _vm.sort }
                    },
                    [
                      _c("template", { slot: "empty" }, [
                        _vm._v("Não há registros.")
                      ]),
                      _c("el-table-column", {
                        attrs: {
                          prop: "numeroProcesso",
                          label: "Processo",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "setor",
                          label: "Setor",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nomeRazaoSocialInteressado",
                          label: "Nome do interessado",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nomeRazaoSocialUsuario",
                          label: "Técnico responsável",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tipo",
                          label: "Tipo de processo",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "municipio",
                          label: "Município",
                          width: "auto",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ações",
                          width: "120",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-dropdown",
                                    { attrs: { trigger: "click" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _vm._v("Ações"),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-arrow-down el-icon--right"
                                          })
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _c("el-dropdown-item", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.abreModal(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-eye"
                                                }),
                                                _vm._v("  Visualizar processo")
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3640750862
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c("app-paginacao", {
                        attrs: {
                          total:
                            _vm.produtividadeAnalista.processosAnalisados
                              .totalElements,
                          pagina: _vm.currentPage,
                          tamanhoPagina: 15
                        },
                        on: { changePage: _vm.changePage }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "margin" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  return _vm.voltar()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-chevron-left" }), _vm._v("  Voltar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07c8e745", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c8e745","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/ProdutividadeSetorPorAnalista.vue
// module id = null
// module chunks = 